export default __webpack_public_path__ + "media/images/landing-29-550x420-f5114e77661fb200afdeb8bd533fb236.jpg";